export type SingleLineTextPublicValue = string;

export const validateSingleLineTextValue = (value: unknown): value is SingleLineTextPublicValue =>
	typeof value === 'string';
